import { combineReducers } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import locationReducer from './locationSlice';


import interpreterReducer from './interpreterSlice';
import profileReducer from './profileSlice';
import typesReducer from './typeSlice';
import subUserReducer from './subUserSlice';
import departmentReducer from './departmentSlice';
import facilityReducer from './facilitiesSlice'; 
import appointmentReducer from './appointmentSlice'; 
import sessionReducer from './sessionSlice'; 
import dashboardReducer from './dashboardSlice'; 
import permissionReducer from './permissionGroupSlice'; 
import actionButtonReducer from './actionButtonSlice';
import invoiceReducer from './invoiceSlice';
import languageReducer from './languageSlice';
import patientReducer from './patientSlice';


export default combineReducers({
    user: userReducer,
    location: locationReducer,
    language: languageReducer,
    
    profile: profileReducer,
    types: typesReducer,
    subUser: subUserReducer,
    interpreter: interpreterReducer,
    departments: departmentReducer,
    facilities: facilityReducer,
    appointments: appointmentReducer,
    sessions: sessionReducer,
    dashboard : dashboardReducer,
    permission : permissionReducer,
    actionButton: actionButtonReducer,
    invoices: invoiceReducer,
    patients: patientReducer,
});
